import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import App from './App';
import "primereact/resources/themes/lara-light-teal/theme.css";    //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";                                //icons
import "/node_modules/primeflex/primeflex.css";
import './theme.css';
import {HashRouter} from "react-router-dom";
import {UserProvider} from "./auth/UserContext";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

<HashRouter>
    <UserProvider>
        <React.StrictMode>
            <App />
        </React.StrictMode>
    </UserProvider>
</HashRouter>

);

